import Visa from '../entities/visa'
import api from 'Plugins/api'

export const VisaTypes = [
  { text: '签证类型', value: '' },
  { text: '旅游签证', value: '1' },
  { text: '商务签证', value: '2' },
  { text: '探亲访友签证', value: '3' },
  { text: '留学签证', value: '4' },
  { text: '夏令营签证', value: '5' }
]

export const IsSpeeds = [
  { text: '常规办理', value: '0' },
  { text: '加急办理', value: '1' }
]

export const KdPayMethods = [
  { key: '1', name: '寄回到付' },
  { key: '2', name: '寄付现结 ' }
]

class VisaBookInterator {
  /**
   * 签证基础数据--国家列表
   */
  static async getContinentList() {
    try {
      const { data = {} } = await api['VisaQuery/GetCountryList']()
      return {
        data
      }
    } catch (error) {
      throw error
    }
  }
  
  /**
   * 领区列表
   */
  static async getConsularList() {
    try {
      const { data = {} } = await api['VisaQuery/GetConsularList']()
      return {
        data
      }
    } catch (error) {
      throw error
    }
  }
  
  /**
   * 签证产品列表
   */
  static async getVisaList(params) {
    try {
      if (params.consularDistId === '1') params.consularDistrictName = null
      
      const { data = {} } = await api['VisaQuery/VisaList'](params)
      let list = []
      if (data.visaListBeans) {
        list = data.visaListBeans.list || []
      }
      return {
        data: list.map(visa => new Visa(visa))
      }
    } catch (error) {
      throw error
    }
  }
  
  /**
   * 签证产品详情
   */
  static async getVisaDetail(params) {
    try {
      const { data: VisaDetail = {} } = await api['VisaQuery/VisaDetail'](params)
      const Associations = await this.getVisaAssociation({
        associationType: '4',
        countryId: VisaDetail.countryId
      })
      
      return {
        VisaDetail: new Visa(VisaDetail),
        Associations
      }
    } catch (error) {
      throw error
    }
  }
  
  /**
   * 签证产品获取下载资料的链接
   */
  static async getVisaAssociation(params) {
    try {
      let { data = [] } = await api['VisaQuery/VisaAssociation'](params)
      if (data.associationBeans) {
        data = data.associationBeans.list || []
      }
      return data
    } catch (error) {
      throw error
    }
  }
  
  /**
   * 签证下单
   * @param {order: VisaOrder} order 签证订单
   */
  static async book (order) {
    try {
      if (order.peopleInfos.length <= 0) throw '请选择出行人'
      if (order.showAddress) {
        if (!order.addressee) throw '请填写收件人'
        if (!order.addresseePhone) throw '请填写收件手机号'
        if (!order.addresseeSite) throw '请填写收件地址'
      }
      if (!order.linkTel) throw '请添加联系人手机号'
      
      const { data = '' } = await api['VisaQuery/visaBook'](order)
			
      return {
        data
      }
    } catch (error) {
      throw error
    }
  }

}

export default VisaBookInterator

